<div class="row">
    <div class="col-12">
        <mat-label >Customer Type</mat-label>
        <mat-select [formControl]="customerTypControl" multiple>
            <mat-option *ngFor="let data of customerList" [value]="data.name">
                {{data.name | titlecase }}
            </mat-option>
          </mat-select>
    </div>
</div>